const STORAGE_KEY = 'orders-screen.deviceId';

/**
 * Returns a stable, browser-local device UUID, generating one on first
 * call. Persists in localStorage; falls back to an in-memory id if
 * storage is unavailable (private mode, etc).
 */
let cached: string | null = null;

export function getOrCreateDeviceId(): string {
  if (cached) return cached;
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing) {
      cached = existing;
      return existing;
    }
    const id = randomUuid();
    window.localStorage.setItem(STORAGE_KEY, id);
    cached = id;
    return id;
  } catch {
    if (!cached) cached = randomUuid();
    return cached;
  }
}

export function randomUuid(): string {
  // Chrome 56 doesn't have crypto.randomUUID(); roll our own RFC4122 v4.
  const bytes = new Uint8Array(16);
  if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(
    16,
    20,
  )}-${hex.slice(20)}`;
}
